import { useEffect } from "react";

const Magazine = () => {
  useEffect(() => {
    window.location.href = "https://magazine.votiamo.com/magazines";
  }, []);
  return (
    // <div style={{ height: "100vh", width: "100%" }}>
    //   <iframe
    //     src={MagazinePDF}
    //     title="Magazine"
    //     width="100%"
    //     height="100%"
    //     style={{ border: "none" }}
    //   ></iframe>
    // </div>
    <></>
  );
};

export default Magazine;
